import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Select from "react-select";
import CustomSelect from "./../Common/CustomSelect";

const CustomCurrencySelect = ({ options, onChange, defaultValue, plug }) => {
  const [data, setData] = React.useState(options || []);
  const [selected, setSelected] = React.useState([]);
  const [update, setUpdate] = React.useState(false);

  React.useEffect(() => {
    if (options.join("") !== data.join("")) {
      setData(options);
      setSelected([]);
      // setSelected(optionsData);
      setUpdate(!update);
    }
    if (update) {
      onChange(selected);
      setUpdate(!update);
    }
  }, [options, update]);

  const handleSelect = e => {
    setSelected(e);
    setUpdate(!update);
  };

  const handleGetDefault = item => {
    let defaultValue = {};
    if (item.currency !== undefined) {
      defaultValue.label = item.currency;
      defaultValue.value = item.currency;
      return defaultValue;
    } else {
      return options[0];
    }
  };

  return (
    <CustomSelectStyle
      options={options}
      onChange={handleSelect}
      defaultValue={handleGetDefault(defaultValue)}
      classNamePrefix="select2-selection"
    />
  );
};

const CustomSelectStyle = styled(CustomSelect)`
  min-width: 75px;

  span {
    display: none;
  }
`;

CustomCurrencySelect.propTypes = {
  options: PropTypes.any.isRequired,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  plug: PropTypes.string,
};

export default CustomCurrencySelect;
